import { makeStyles } from "@material-ui/core/styles";

export const OnboardingDataFormJss = makeStyles((theme) => ({
  root: {
    backgroundColor: "rgba(245, 245, 245, 1)",
    paddingLeft: theme.spacing(4),
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(10),

  },
  GridCaptcha: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
        display: "flex",
        justifyContent: "center",
    },
  },
  typographyClass: {
    fontSize: '1rem',
    color: '#707070',
    [theme.breakpoints.down("sm")]: {
      fontSize: '0.875rem',
    },
  },
  sendButtonGrid: {
    padding: theme.spacing(4),
    '& .MuiButton-contained.Mui-disabled': {
      backgroundColor: theme.palette.white.main,
      border: '1px solid #BCBCBC',
      color: '#BCBCBC',
    }
  },
  dialogTitleIcon: {
    fontSize: 92,
  },
  dialogBody: {
    paddingTop: theme.spacing(12),
    paddingBottom: theme.spacing(12),
    textAlign: "center",
  },
  list: {
    paddingTop: theme.spacing(5),
    display: 'flex',
    flexDirection: 'row',
    '& .MuiAvatar-root': {
      height: '3.5rem',
      width: '3.5rem',
      background: 'transparent',
      marginLeft: theme.spacing(3),
    }
  },
  iconContainer: {
    '& .MuiSvgIcon-root': {
      color: '#008330',
      fontSize: '2.5rem',
    },
  },
  listItemTextRegular: {
    color: '#000000',
    fontSize:'1rem',
    fontWeight: '500',
    [theme.breakpoints.down("md")]: {
      fontSize:'1rem',
    },
  },
  dividerFirst: {
    "&.MuiDivider-root": {
      borderTop: "solid purple"
    },
    "& .MuiDivider-wrapper": {
      fontSize: 16
    }
  }, 
  divider: {
    "&.MuiDivider-root": {
      borderTop: "solid"
    },
    "& .MuiDivider-wrapper": {
      fontSize: 16
    }
  },
  outlinedWarning: {
    marginRight: theme.spacing(4),
    padding: '0px 24px 0px 0px',
    boxShadow: 'none',
    background: '#FFF9E0',
    boxSizing: 'border-box',
    border: '1.4px solid #FFCC00',
    '& .MuiAlert-message': {
      fontFamily: 'Barlow',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '17px',
      color: '#1A1A1A',
    },
    '& .MuiAlert-icon': {
      '& svg': {
        width: '28px',
        height: '28px',
        stroke: 'none',
        '& path': {
          fill: '#FFCC00',
          fillOpacity: '1',
          stroke: theme.palette.warning.light,
        },
        transform: 'scale(1)',
      },
    },
  },
  insideModal: {
    paddingLeft: theme.spacing(7),
    paddingRight: theme.spacing(7),
    textAlign: 'center',
    '& p': {
      fontFamily: 'Barlow',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '17px',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'justify',
      color: '#464646',
    },
    '& img': {
      height: '156px',
      filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.4))',
    }
  },
  titleModal: {
    fontFamily: 'Barlow',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '16px',
    lineHeight: '19px',
    textAlign: 'center',
    color: '#434343',
  }  
}));
